import { GameCommunicationBetSender as CoreBetSender } from '@pp/core/src/controllers/gameCommunication/senders/GameCommunicationBetSender';
import type { GameCommunicationSenderType } from '@pp/core/src/controllers/gameCommunication/types';

import { Bets } from '../../../config/bets';
import type { GameStore } from '../../../store/GameStore';

export class GameCommunicationBetSender extends CoreBetSender {
  send(_: never, store: GameStore, sender: GameCommunicationSenderType): void {
    const state = store.getState();
    const gameChannel = state.gameState.gameChannel;
    const gameId = state.gameState.gameId;
    const userId = state.config.playerConfig?.userId;
    const betStack = state.bets.betStack;
    const { autoCashout } = state;

    const bets = betStack[betStack.length - 1]?.betSpots || {};

    let betTags = '';
    const cashoutMul = {
      [Bets.ONE]: 0,
      [Bets.TWO]: 0,
    };
    Object.keys(bets).forEach((betSpot) => {
      cashoutMul[betSpot as unknown as Bets] = autoCashout[betSpot].isEnabled
        ? autoCashout[betSpot].cashoutMultiplier
        : -1;
    });
    Object.keys(bets).forEach((betSpot) => {
      if (bets[betSpot].value > 0) {
        betTags += `<bet amt="${bets[betSpot].value}" bc="${betSpot}" ck="${Date.now()}"${
          cashoutMul[betSpot as unknown as Bets] ? ` mul="${cashoutMul[betSpot as unknown as Bets]}"` : ''
        }/> `;
      }
    });

    if (gameChannel && userId) {
      let message = '';
      message += `<command channel="${gameChannel}">`;
      message += `<lpbet gm="highflyer_desktop" gId="${gameId}" uId="${userId}" ck="${Date.now()}">`;
      message += betTags;
      message += '</lpbet>';
      message += '</command>';

      sender?.(message);
    }
  }
}
